import type { CapiProductPage } from 'types/capi/pdp';

import Breadcrumbs from '~/components/BreadCrumbs';
import usePageData from '~/hooks/usePageData';

const PdpBreadcrumbs = () => {
  const product = usePageData<CapiProductPage>();

  return <Breadcrumbs breadcrumbs={product.breadcrumbs} />;
};

export default PdpBreadcrumbs;
